







































import { defineComponent, PropType, ref, onMounted, onBeforeUnmount } from '@vue/composition-api';
import VSwatches from 'vue-swatches';
import "vue-swatches/dist/vue-swatches.css";
import { BModal } from 'bootstrap-vue';
import * as Common from "../commons/common"

export default defineComponent({
  props: {
    selectedSaitenStickyNote: {
      type: Object,
      required: false,
    },
  },
  components: {
    "v-swatches": VSwatches,
  },
  setup (props, context) {

    const modalSaitenStickyNoteRef = ref<InstanceType<typeof BModal>>();

    const show = () => {
      modalSaitenStickyNoteRef.value.show();
    }

    const hidden = () => {
      context.emit("hidden");
    }

    const edited = () => {
      context.emit("saiten-sticky-note-edited");
    }

    return {
      modalSaitenStickyNoteRef,
      show,
      hidden,
      edited,
    }
  }
});
